module.exports = __webpack_public_path__ + "img/logomain.98930ef4.png";